<template>
  <ul :class="isDropDown ? 'dropdown-menu' : 'navbar-nav'" :id="id">
    <template v-for="menuItem of menuItems">
      <template v-if="menuItem.menuItems">
        <li :class="'nav-item' + ' dropdown' + menuItem.label" :key="menuItem.label">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="collapse" :data-target="'#' + menuItem.label + 'root'">
            <span v-if="menuItem.icon" class="fontIcon"><font-awesome-icon :icon="menuItem.icon"></font-awesome-icon></span>
            {{menuItem.label}}
            <font-awesome-icon :icon="['far', 'chevron-down']"></font-awesome-icon>
          </a>
          <SideMenuRoot :isDropDown="true" :menuItems="menuItem.menuItems" :id="menuItem.label + 'root'" :key="menuItem.label + 'root'" />
        </li>
      </template>
      <template v-else>
        <SideMenuNode :isDropDown="isDropDown" :menuItem="menuItem" :key="menuItem.label" />
      </template>
    </template>
  </ul>
</template>

<script>
import SideMenuNode from '@/components/Menus/SideMenuNode.vue'

export default {
  name: 'SideMenuRoot',
  components: {
    SideMenuNode
  },
  props: {
    menuItems: null,
    isDropDown: false,
    id: ''
  },
  watch: {
    menuItems: function (newVal) {
      this.menuItems = newVal
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Menus/SideMenuRoot.vue